export const CHARACTERS = {
  guardian: { name: 'Guardião', sprites: [98, 97, 96] },
  mage: { name: 'Mago', sprites: [86, 85, 84] },
  explorer: { name: 'Explorador', sprites: [88, 100, 87] },
};
export const EVOLUTIONS = [
  { name: 'Aprendiz', level: 1 },
  { name: 'Aventureiro', level: 3 },
  { name: 'Mestre', level: 6 },
];
export function characterProgress(xp = 0, character = 'guardian') {
  const points = Number.isFinite(Number(xp))
    ? Math.max(0, Math.floor(Number(xp)))
    : 0;
  const level = 1 + Math.floor(points / 100);
  const stage =
    EVOLUTIONS.filter(evolution => level >= evolution.level).length - 1;
  const identity = CHARACTERS[character] || CHARACTERS.guardian;
  const next = EVOLUTIONS[stage + 1];
  return {
    xp: points,
    level,
    stage,
    name: EVOLUTIONS[stage].name,
    sprite: identity.sprites[stage],
    characterName: identity.name,
    progress: points % 100,
    remaining: 100 - (points % 100),
    next: next ? { ...next, remaining: (next.level - 1) * 100 - points } : null,
  };
}
